import { RadioStyled } from '@nike/nike-design-system-components';
import styled from '@emotion/styled';
import { CustomRadioStyledProps } from '../../types/CustomRadioStyledProps';

const CustomRadioStyled = styled(RadioStyled)<CustomRadioStyledProps>`
  label::after {
    content: '${(props) => props.afterLabel}';
    display: block;
  },
`;

export default CustomRadioStyled
